export default __webpack_public_path__ + "static/media/trusted-icon.d5782c74.png";